const DEFAULT_TITLE = "Plateforme mon bureau d’études.";
const DEFAULT_DESCRIPTION = "";

const getOrCreateDescriptionTag = () => {
	const existingTag = document.querySelector('meta[name="description"]');
	if (existingTag) {
		return existingTag;
	}

	const descriptionTag = document.createElement("meta");
	descriptionTag.setAttribute("name", "description");
	document.head.appendChild(descriptionTag);
	return descriptionTag;
};

export const applySeoMeta = ({ title, description } = {}) => {
	document.title = title || DEFAULT_TITLE;

	const descriptionTag = getOrCreateDescriptionTag();
	descriptionTag.setAttribute("content", description || DEFAULT_DESCRIPTION);
};
